const WHITESPACE_ONLY_DESCRIPTION_REGEX = /^[\s\u00A0]*$/;

const sanitizeAudioNoteDescription = (value: string | null | undefined): string => {
    if (typeof value !== 'string') {
        return '';
    }

    const normalizedValue = value.replace(/\u00A0/g, ' ');

    if (WHITESPACE_ONLY_DESCRIPTION_REGEX.test(normalizedValue)) {
        return '';
    }

    return normalizedValue;
};

export default sanitizeAudioNoteDescription;
